// API URLs configuration
export const urls = {
  baseURL: process.env.REACT_APP_API_BASE_URL || 'https://admin.lechalo.co.in/api/v1/',
  baseURL1: 'https://admin.lechalo.co.in/',
  locationBaseURL: 'https://location.lechalo.co.in/api/v1/',
  bidBaseURL: 'https://bid.lechalo.co.in/api/v1/',
  
  // Auth endpoints
  sendotp: 'sendotp',
  login: 'login',
  verifymoboremail: 'verify',
  register: 'register',
  logout: 'logout',
  switchAccount: 'auth/switch-account',
  is_online: 'auth/is-online',
  me: 'customer/info',
  deleteAccount: 'users/account-delete',
  
  // Document endpoints
  aadharcard: 'auth/aadhar-card',
  pancard: 'auth/pan-card',
  drivinglicence: 'auth/driving-licence',
  vehicleregistrationdetail: 'auth/vehicle-registration',
  
  // Banner endpoints
  bannerimage: 'banners',
  adsimage: 'banners/ads',
  getbanner: 'banners/getbanner',
  
  // Vehicle endpoints
  vehicaltype: 'vehicle-type',
  addvehicle: 'vehicle',
  editvehicle: 'vehicle/editvehicle/',
  multivehicleselect: 'vehicle/select-vehicle',
  vehicleDeleteUrl: 'vehicle/update-vehicle/',
  seatSelection: 'vehicle/seatSelection/',
  
  // Vehicle brand/model endpoints
  brandlist: 'brands',
  getBrandByVehicleId: 'brands/get-brand-by-vehicletype-id',
  modellist: 'models/get-model-by-brand-id',
  
  // City endpoints
  getCity: 'get-cities',
  getCities: 'get-cities',
  getallCityes: 'city/12',
  getTaluka: 'taluka/',
  getparcelpasseCities: 'get-parcelpassenger-cities',
  
  // Location endpoints
  serchplace: 'location/search-places',
  getaddressfromlatlng: 'location/get-address-from-lat-lng',
  getDirectionFromLatLng: 'location/get-directions-from-lat-lng',
  recentlocation: 'getrecentaddress',
  
  // Trip endpoints
  getupcomingTripCustomerorDriver: 'trips/up-coming',
  getcompletedTripCustomerorDriver: 'trips/completed-trips',
  customerhistory: 'orders/history',
  closeRide: 'orders/close-ride',
  
  // Order endpoints
  placeOrder: 'orders',
  getOrderList: 'orders/',
  getDriverOrderList: 'orders/get-orders',
  driverignoreorder: 'orders/ignore-order/',
  ordercancel: 'orders/cancel',
  driverreached: 'orders/reached-at-location/',
  driverarrived: 'orders/arrived-at-location/',
  resendorder: 'orders/resend-order/',
  parcelPickupOtp: 'orders/show/',
  verifyotpstartride: 'orders/verify-parcel',
  verifyotpdeliveryparcel: 'orders/parcel-delivered',
  
  // Bid endpoints
  postbid: 'bids', 
  customerapprovebid: 'bids/approve-bid/',
  approveBid: 'bids/approve-bid/',
  driverlist: 'orders/get-bid-by-order/',
  checkdriverselect: 'orders/get-selected-driver',
  
  // User profile endpoints
  checkuserdetail: 'users/user_details',
  getProfile: 'users/user_details',
  updateuserprofile: 'users/update',
  driverlocation: 'users/location/store',
  walletbalance: 'users/wallet-balance',
  deducatwalletbalance: 'users/pay-from-balance',
  
  // Payment endpoints
  payment: 'payumoney/pay',
  walletaddmoney: 'user-wallet-transcation',
  wallethistory: 'payments/history',
  addwalletpayment: 'driver-wallet-add/',
  commitionvalue: 'settings/admin-commission',
  
  // File upload
  uploadfile: 'attachments/upload',
  
  // Goods type
  getGoodsType: 'goods-type',
  
  // Feedback
  feedbackapi: 'feedback',
  
  // Driver earnings
  drivererning: 'daily-earnings',
  
  // Cancel reasons
  cancelreasons: 'reasons',
  
  // Coupon
  checkCouponCode: 'coupon/checkCouponCode',
  
  // Web pages
  opensourcelicenses: 'web-pages/open-source-licenses',
  termsandcondition: 'web-pages/terms-and-conditions',
  privacypolicy: 'web-pages/privacy-policy',
  cancellationpolicy: 'web-pages/cancellation-policy-api',
  triphelp: 'web-pages/help-with-trip',
  accountandappissue: 'web-pages/account-and-app-issue',
  earningsandpayments: 'web-pages/earnings-and-payments',
  safteyapi: 'web-pages/saftey-api',
  
  // ComfyShuttle endpoints
  getPickupPoints: 'get-pick-up-points/',
  getSchedule: 'schedule',
  bookcomfy: 'shuttle',
  bookcomfyshuttle: 'book-comfy-shuttle/',
  getbookingcomfylist: 'customer/bookings/list',
  getBusSchedule: 'getScheduleBus',
  
  // Settings and notifications
  settings: 'settings',
  notifications: 'notifications',
  getLatestVersion: 'settings/getlatestversion',
  
  // Package payment
  packagepay: 'package-pay',
  
  // External APIs
  distanceMeter: 'https://maps.googleapis.com/maps/api/distancematrix/json',
  
  // Additional missing endpoints
  getdriverOnCall: 'driver-on-call',
  driverOnCallPackage: 'driver-on-call-package',
  customerCallList: 'customer-call-list',
  faq: 'faqs',  // FAQ endpoint - plural as per API spec
  tours: 'tours',
};
